import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

interface PayInvoiceResponse {
  invoice_id: string;
  hosted_url: string;
  pdf_url: string;
}

export class PayInvoiceData {
  @Required("pdf url cannot be empty")
  @IsString("pdf url must be a string")
  pdfUrl: string;

  @Required("hosted url cannot be empty")
  @IsString("hosted url must be a string")
  hostedUrl: string;
}

const transformAndValidateData = (
  response: PayInvoiceResponse
): PayInvoiceData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, PayInvoiceData);
  } catch (error) {
    console.error("Miuta price data validation failed:", error.message);
    throw error;
  }
};

/** 获取 stripe 发票 */
export const payInvoice = async (orderNo: string): Promise<PayInvoiceData> => {
  const res = await api.get<PayInvoiceResponse>('/pay/invoice', {
    invoice: orderNo,
  });
  const data = transformAndValidateData(res.data);
  return data;
}